module.exports = __webpack_public_path__ + "static/img/dropdown-arrow.f2dcbe64.svg";